import {
  getJobsPending, getJobsSuccess, getJobsError,
  getJobPending, getJobSuccess, getJobError,
  updateJobPending, updateJobSuccess, updateJobError,
  searchJobsPending, searchJobsSuccess, searchJobsError,
  getApplicantJobsPending, getApplicantJobsSuccess, getApplicantJobsError,
  getEmployerJobsPending, getEmployerJobsSuccess, getEmployerJobsError,
  createJobPending, createJobSuccess, createJobError,
  applyJobPending, applyJobSuccess, applyJobError,
  unapplyJobPending, unapplyJobSuccess, unapplyJobError,
  removeJobPending, removeJobSuccess, removeJobError,
  getApplicantsPending, getApplicantsSuccess, getApplicantsError, getAppliedJobsPending, getAppliedJobsSuccess, getAppliedJobsError
} from '../actions/job';

import {JobService, ApplicantDashboard} from '../../lib/qc-api-client';

export function getJobs() {
  return dispatch => {
    dispatch(getJobsPending());
    JobService.getJobs().then(response => {
      dispatch(getJobsSuccess({
        jobs:       response.data.jobs,
        filters:    response.data.filters,
        totalJobs:  response.data.total
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getJobsError(error));
    })
  }
}

export function getApplicantJobs(user) {
  return dispatch => {
    dispatch(getApplicantJobsPending());
    JobService.getApplicantJobs(user).then(response => {
      dispatch(getApplicantJobsSuccess({
        jobs:       response.data.jobs,
        filters:    response.data.meta.filters,
        totalJobs:  response.data.total
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getApplicantJobsError(error));
    })
  }
}

export function getAppliedJobs(user) {
  return (dispatch) => {
    dispatch(getAppliedJobsPending());
    ApplicantDashboard.getData(user)
      .then((response) => {
        dispatch(getAppliedJobsSuccess(response.data));
      })
      .catch((error) => dispatch(getAppliedJobsError(error)));
  };
}

export function getEmployerJobs(user) {
  return dispatch => {
    dispatch(getEmployerJobsPending());
    JobService.getEmployerJobs(user).then(response => {
      dispatch(getEmployerJobsSuccess({
        jobs:       response.data.jobs,
        filters:    response.data.filters,
        totalJobs:  response.data.total
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getEmployerJobsError(error));
    })
  }
}

export function searchJobs(keywords, location, options) {
  return dispatch => {
    dispatch(searchJobsPending());
    JobService.searchJobs(keywords, location, options).then(response => {
      dispatch(searchJobsSuccess({
        jobs:       response.data.jobs,
        filters:    response.data.filters,
        totalJobs:  response.data.total
      }));
      return response.data.jobs;
    }).catch(error => {
      console.error(error)
      dispatch(searchJobsError(error));
    })
  }
}

export function updateJob(job) {
  return dispatch => {
    dispatch(updateJobPending());
    JobService.updateJob(job).then(response => {
      dispatch(updateJobSuccess({
        job: response.data.job
      }));
      return response.data.job;
    }).catch(error => {
      console.error(error)
      dispatch(updateJobError(error));
    })
  }
}

export function createJob(job, employer) {
  return dispatch => {
    dispatch(createJobPending());
    JobService.createJob(job, employer).then(response => {
      dispatch(createJobSuccess({
        job: response.data
      }));
    }).catch(error => {
      console.error(error)
      dispatch(createJobError(error));
    })
  }
}

export function getJob(slug, include = null) {
  return (dispatch) => {
    dispatch(getJobPending());
    JobService.getJob(slug)
      .then((response) => {
        const job = response.data.job;
        dispatch(getJobSuccess({ job }));
        if (include && include.applicants) {
          dispatch(getApplicants(job));
        }
        return response.data.job;
      })
      .catch((error) => {
        console.error(error);
        dispatch(getJobError(error));
      });
  };
}

export function getApplicants(job, status = null) {
  return dispatch => {
    dispatch(getApplicantsPending());
    JobService.getApplicants(job, status).then(response => {
      dispatch(getApplicantsSuccess({
        applicants: response.data.applicants
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getApplicantsError(error));
    })
  }
}

export function getAllAplicants(user) {
  return (dispatch) => {
    dispatch(getApplicantsPending());
    JobService.getAllApplicants(user).then((response) => {
      dispatch(
        getApplicantsSuccess({
          applicants: response.data.applicants,
        }).catch((error) => {
          dispatch(getApplicantsError(error));
        })
      );
    });
  };
};

export function removeJob(job) {
  return (dispatch) => {
    dispatch(removeJobPending());
    JobService.remove(job)
      .then((response) => {
        dispatch(removeJobSuccess(response.data));
      })
      .catch((error) => {
        dispatch(removeJobError(error));
      });
  };
}

export function applyJob(user, profileId, slug) {
  const message = 'You have successfully applied to this job.'
  return dispatch => {
    dispatch(applyJobPending());
    JobService.apply(user, profileId, slug).then(response => {
      dispatch(applyJobSuccess({message}));
      return message;
    }).catch(error => {
      console.error(error)
      dispatch(applyJobError(error));
    })
  }
}

export function unapply(applicant, job) {
  const message = 'You have successfully removed this job.'
  return dispatch => {
    dispatch(unapplyJobPending());
    JobService.unapply(applicant, job)
      .then(response => {
        dispatch(unapplyJobSuccess({message}));
      }).catch(error => {
        console.error(error)
        dispatch(unapplyJobError(error));
      })
  }
}
